import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import type { ReactNode } from 'react';

export interface ISectionHeadingProps {
  children: ReactNode;
  marginBottom?: number;
}

export const SectionHeading = ({ children, marginBottom = 8 }: ISectionHeadingProps) => (
  <Typography variant="subtitle1"
    as="h3"
   
    color={colors.neutral[600]}
    style={{ margin: 0, marginBottom }}
  >
    {children}
  </Typography>
);
